export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyAWLSjl_XqviQEbl3yDKR2SLubg85ZRn00",
    authDomain: "anmeldung-prod.firebaseapp.com",
    projectId: "anmeldung-prod",
    storageBucket: "anmeldung-prod.appspot.com",
    messagingSenderId: "233430993563",
    appId: "1:233430993563:web:6ffa21645c2d5b14f0543e",
    measurementId: "xxxxxxxxxxxxxxxx"
  },
  functionsURL: 'https://europe-west1-anmeldung-prod.cloudfunctions.net/',
  sentry: {
    dsn: "https://713353609887dc814634e0b9eea3745b@o4507839984762880.ingest.de.sentry.io/4507839988695120",
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", "https://anmeldung.cjg-fn.de/", "https://freizeitanmeldung-44343.firebaseapp.com/"],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  }
};
